<template>
  <div>
    <div class="eject_content" style="width:100%">
      <div class="eject_con">
        <!-- <a-radio-group
          v-model="changeValue" default-value="img" button-style="solid" style="    display: none;" @change="handleChange"
        >
          <a-radio-button value="img">
            图片
          </a-radio-button>
        </a-radio-group> -->
        <div style="margin-bottom:30px">
          <span style="font-size:18px;color:#222222 ">查看监管照片</span><span style="font-size:#999999;font-size:14px">（默认展示最新一周）</span>
        </div>
        <div>
          <a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }" label="选择日期:">
            <a-range-picker
              v-model="times" value-format="YYYY-MM-DD"
              @change="onTime"
            />
          </a-form-item>
        </div>
      </div>
      <div>
        <a-spin :spinning="spinImg" tip="加载中...">
          <div class="pic">
            <div v-if="imgdata && imgdata.length > 0">
              <div v-for="(item,index) in imgdata" :key="index">
                <div class="pic_top">
                  <div>
                    <span></span><span>{{ item.date }}</span>
                  </div>

                  <div v-if="item.photoList.length > 6" style="color: #1890ff;cursor: pointer" @click="toggle(item,item.date)">
                    <a-icon v-show="item.show" type="up" />
                    <a-icon v-show="!item.show" type="down" />
                    {{ item.show ? '收起': '展开' }}
                  </div>
                </div>
                <div class="pic_bot">
                  <!-- <div class="listBody"> -->
                  <viewer :images="item.photoList" class="listBody">
                    <a
                      v-for="(imglt,inde) in item.photoList" v-if="inde < 6"
                      :key="inde" href="javascript:;" class="img_list" @click="imgTo(imglt,item.date)"
                    >
                      <img
                        :src="imglt.image + '?x-oss-process=image/resize,m_fill,w_650,h_350/quality,q_30'" :images="imglt.image" style="margin-bottom:20px"
                      >
                      <!-- <div class="viewer_cen">
                        <div style="font-size:12px">{{ imglt.alarmEvent }}</div></div> -->
                      <div class="listTime"><span>{{ imglt.createTime }}</span></div>

                    </a>

                    <a
                      v-for="(imglt,inde) in item.photoList" v-show="item.show" v-if="inde >= 6" :key="inde" href="javascript:;" class="img_list" @click="imgTo(imglt,item.date)"
                    >

                      <img :src="imglt.image + '?x-oss-process=image/resize,m_fill,w_650,h_350/quality,q_30'" :images="imglt.image" style="margin-bottom:20px">
                      <!-- <div class="viewer_cen">
                        <div style="font-size:12px">{{ imglt.alarmEvent }}</div></div> -->
                      <div class="listTime"><span>{{ imglt.createTime }}</span></div>

                    </a>
                  </viewer>
                </div>
              </div>

              <!-- </div> -->
            </div>
            <div v-else>
              <a-empty />
            </div>
          </div>
        </a-spin>
        <!-- <div v-show="changeValue === 'video'" class="video" style="text-align: center;margin: 20px 0;">
          <div v-if="videoArr && videoArr.length !== 0">
            <template v-for="(item,index) in videoArr">
              <iframe
                v-if="item.src"
                :key="index"
                class="ysOpenDevice"
                :src="item.src"
                width="80%"
                height="500"
                allowfullscreen
              >
              </iframe>
              <div v-else :key="index" class="ysOpenDevice">
                {{ item.name + '(' + item.msg + ')' }}
              </div>
            </template>
          </div>
          <div v-else>
            <a-empty />
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getWebcamAlarmPhoto } from '@/api/system'
export default {
  data () {
    return {
      imgdata: [],
      loading: false,
      recordItem: {},
      times: [],
      spinImg: false
    }
  },
  mounted () {
    const id = this.$route.query.id
    this.linkDetails(id,)
  },
  methods: {
    linkDetails (val) {
      this.spinImg = true
      this.imgvisible = true
      // 现在的时间
      var dates = new Date()
      const year = dates.getFullYear()
      const mounth = (dates.getMonth() + 1).toString().padStart(2, '0')
      const day = dates.getDate().toString().padStart(2, '0')
      const time1 = year + '-' + mounth + '-' + day

      // 一周前的时间
      var time = (new Date()).getTime() - 6 * 24 * 60 * 60 * 1000
      var tragetTime = new Date(time)
      const tyear = tragetTime.getFullYear()
      const tmounth = (tragetTime.getMonth() + 1).toString().padStart(2, '0')
      const tday = tragetTime.getDate().toString().padStart(2, '0')
      const times = tyear + '-' + tmounth + '-' + tday
      this.times.push(times, time1)
      const param = {
        startTime: this.times[0],
        endTime: this.times[1],
        id: val
      }
      getWebcamAlarmPhoto(param)
        .then(res => {
          const arr = res.result
          arr.forEach((val) => {
            val.show = false
          })
          this.imgdata = arr
          setTimeout(() => {
            this.spinImg = false
          }, 1000)
        })
    },
    onTime (val) {
      this.times = val
      this.linkDetails(this.$route.query.productId)
    },
    toggle (item) {
      item.show = !item.show
    },
    imgTo (val, time) {
      this.imgs = val
      this.starttimes = time
      console.log(this.starttimes, ' this.starttimes')
      this.modelvisibless = true
    },
    viewImg (id, time) {
      this.external = {}
      const pamar = {
        id,
        type: 1
      }
      this.imgchoice = 'a'
      this.imgId = id
      this.starttime = time
      getPhotoList(pamar).then(res => {
        if (res.result.length !== 0) {
          this.external = res.result[0]
        }
      })
    }
  }
}
</script>

<style scoped>
.eject_content {
  min-height: 400px;
  padding: 0 34px;
  background: #FFFFFF;
}
.eject_con {
text-align:center;
height: 100px;
display: flex;
justify-content: space-between;
align-items: center;
}
.pic_top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 26px;
}
  .listBody {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .img_list {
    width: 256px;
    height: 100%;
    position: relative;
  }
  .listTime {
position: absolute;
width:100%;
text-align: center;
top: 10px;
color: #fff;
/* left: -30px; */
width: 72px;
height: 24px;
line-height: 24px;
background: rgba(0, 0, 0, 0.5);
box-shadow: 2px 0px 4px 0px rgba(77, 77, 77, 0.3);
border-radius: 0px 100px 100px 0px;
  }
</style>
